module.exports = __webpack_public_path__ + "img/leaderboard.312926fe.png";